import React from 'react';
import Link from 'gatsby-link';

import face from './face.jpg';
import github from './github.svg';
import mobile from './mobile.svg';
import envelope from './envelope.svg';

import Helmet from 'react-helmet';

import './cv.css';

const SecondPage = () => (
  <div>
    <Helmet
      title="Rickert Mulder"
      meta={[
        { name: 'description', content: 'Rickert Mulder' },
        {
          name: 'keywords',
          content:
            'Rickert, Mulder, Developer, Python, JavaScript, React, Angular, Postgres, Nginx, SaltStack, RabbitMQ, Linux, Node, C++, QT, OpenGL'
        }
      ]}
    />
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '2rem'
      }}
    >
      <div
        style={{
          backgroundImage: `url(${face})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          width: 160,
          height: 160,
          borderRadius: '50%'
        }}
      />
      <div
        style={{
          display: 'flex',
          // justifyContent: 'center',
          flexGrow: 1,
          marginLeft: '2rem'
        }}
      >
        <div>
          <h1>Rickert Mulder</h1>
          <div>
            <a href="mailto:circlingthesun@gmail.com">
              <img
                height="16px"
                style={{ marginBottom: -2, width: 16 }}
                src={envelope}
              />
              &nbsp; circlingthesun@gmail.com
            </a>

            <br />
            <a href="tel:+27720700542">
              <img
                height="16px"
                style={{ marginBottom: -2, width: 16 }}
                src={mobile}
              />&nbsp; +27 72 070 0542
            </a>
            <br />
            <a href="https://github.com/circlingthesun">
              <img
                height="16px"
                style={{ marginBottom: -2, width: 16 }}
                src={github}
              />&nbsp; https://github.com/circlingthesun
            </a>
          </div>
        </div>
      </div>
    </div>

    <h2>Experience</h2>

    <ul>
      <li>
        November 2013 - Present<br />
        Co-Founder at <a href="https://bookem.co.za">Bookem</a> <br />
        I'm responsible for all things code, and product development.
        <br />
        Python, JavaScript, React, Angular, Postgres, Nginx, SaltStack,
        RabbitMQ, Linux
      </li>

      <li>
        March 2016 - Present<br />
        Software Developer at{' '}
        <a href="https://whereismytransport.com">WhereIsMyTransport</a>
        <br />
        I'm responsible for developing project frontends. This includes our
        developer portal, an incident management system for transport operators,
        and a geospatial web based management portal for route capturing.
        <br />
        JavaScript, Angular, React, Node
      </li>

      <li>
        December 2018 - Present<br />
        Software Developer at SCSpheres
        <br />
        SCSpheres is a document management solution for boardroom meetings used
        by the Nedgroup and other large companies. I've been involved since it's
        inception and helped architect the front end, design user flows, and
        implementation.
        <br />
        Django, Python, React, Redux, Postgres
      </li>

      <li>
        October 2018 - December 2018<br />
        Software Developer at New Creative Collective
        <br />
        I was contacted 3 days before the Launch of Elixxir.io at an event in
        Las Vegas to complete the website and ensure it is mobile ready /
        responsive. After a successful launch, I continued to implement other
        features and designs.
        <br />
        Vue, Nuxt.js, Node
      </li>

      <li>
        June 2015 - November 2015<br />
        Software Developer at University of Cape Town<br />
        I worked on a commercialisation effort of terrain synthesis software for
        the games and visual effects industry created by Prof James Gain, A/Prof
        Patrick Marais, and Dr Bruce Merry. This involved a major refactor of
        the interface code to resolve stability issues, improve usability,
        support new features, and enable efficient rendering of large data sets.
        <br />
        C++, QT, OpenGL
      </li>

      <li>
        April 2013 - August 2013<br />
        Software Developer at Eric Schollar and Associates (ESA)<br />
        I built a data entry and analytics system for auditing public secondary
        schools in Gauteng.
        <br />
        JavaScript, Python, Angular, Nginx, Postgres, Linux
      </li>
    </ul>

    <h2>Education</h2>
    <ul>
      <li>2012 - 2016 University of Cape Town - MSc, Computer Science</li>

      <li>2011 University of Cape Town - BSc (Hons), Computer Science</li>

      <li>
        2008 - 2010 University of Cape Town - BSc IT, Applied Computing and
        Psychology
      </li>
      <li>
        2006 - 2007 University of South Africa - BCom, Marketing Management
        (Incomplete)
      </li>
    </ul>
  </div>
);

export default SecondPage;



// WEBPACK FOOTER //
// ./src/pages/cv.js